module.exports = __webpack_public_path__ + "assets/images/ead2d596be596fe9567886b0401f6612.png";